import 'isomorphic-unfetch'; // Optional for IE11 support
import ApolloClient from 'apollo-boost';
import { InMemoryCache } from 'apollo-cache-inmemory';

export const apolloClient = new ApolloClient({
    // Optional for IE11 support
    fetchOptions: { fetch },
    // You should use an absolute URL here
    cache: new InMemoryCache(),
    uri: 'https://v1.csuitegraph.com/v1/graphql',
});
